import React, { useEffect, useState } from "react";
import Axios from "../../Axios";
import { Card, Table, Tag, Typography } from "antd";
import { render } from "less";
import { formatNumber } from "../../helpers/formatters";

const { Text } = Typography;

const PenaltiesReport = ({type, title}) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const getFinesByCategory = async () => {
    setIsloading(true);
    try {
      const res = await Axios.get("/analytics/fines-by-category?type="+type);
      setData(res.data);
    } catch (error) {
      console.error("Error al cargar las multas:", error);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    getFinesByCategory();
  }, []);

  const total = data.reduce((sum, item) => sum + item.qty, 0);

  const columns = [
    {
        title: "Nombre",
        dataIndex: "name",
        key: "name",
        width: 100,
        render: (value) => value.substring(0,10)
      },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      render: (value) => <span style={{textTransform: 'uppercase'}}>{ value.length > 140 ? value.substring(0,140) + '...' : value}</span>
    },
    {
      title: "Cantidad",
      dataIndex: "qty",
      key: "qty",
      align: "right",
      render: (value)=> formatNumber(value)
    },
  ];

  return (
    <Card title={title} style={{ marginTop: "10px" }}>
      <Table
        size="small"
        columns={columns}
        dataSource={data}
        loading={isLoading}
        rowKey={(record, index) => index}
        pagination={false}
        summary={() => (
          <Table.Summary.Row>
             <Table.Summary.Cell>
            </Table.Summary.Cell>
            <Table.Summary.Cell>
              <Text strong>Total</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell className="right">
              <Tag color="green">{formatNumber(total)}</Tag>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </Card>
  );
};

export default PenaltiesReport;
